import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

export function PageHeader({ title, back = false }: { title: string; back?: boolean }) {
  const navigate = useNavigate();
  return (
    <header className="page-header">
      {back ? (
        <button className="icon-button" type="button" aria-label="返回" onClick={() => navigate(-1)}>
          <ChevronLeft size={26} />
        </button>
      ) : (
        <span className="header-spacer" />
      )}
      <h1>{title}</h1>
      <span className="header-spacer" />
    </header>
  );
}
